import * as mutationTypes from 'store/mutationTypes'

/**
 * @return {Promise}
 */
export const setCurrentChatMessages = function ({ commit }, messages) {
  return commit(mutationTypes.SET_CURRENT_CHAT_MESSAGES, messages)
}

/**
 * @return {Promise}
 */
export const setCurrentChatTotalMessages = function ({ commit }, total) {
  return commit(mutationTypes.SET_CURRENT_CHAT_MESSAGES_TOTAL, total)
}

/**
 * @return {Promise}
 */
export const setCurrentChatTotalUnreadMessages = function ({ commit }, total) {
  return commit(mutationTypes.SET_CURRENT_CHAT_MESSAGES_TOTAL_UNREAD, total)
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/actions.js